// src/components/GamifiedConfirmModal.js
import React, { useEffect } from 'react';
import '../css/GamifiedConfirmModal.css';

export default function GamifiedConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  talentName = 'this talent',
  creditDelta = +1, // show +1 refund by default
}) {
  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const deltaText = creditDelta > 0 ? `+${creditDelta}` : `${creditDelta}`;

  return (
    <div className="gcfm-overlay" onClick={onClose}>
      <div className="gcfm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Floating “particles” for a subtle gamified vibe */}
        <div className="gcfm-particles">
          {Array.from({ length: 16 }).map((_, i) => (
            <span key={i} style={{ '--i': i }} />
          ))}
        </div>

        <div className="gcfm-header">
          <h3 className="gcfm-title">Cancel Shortlist?</h3>
          <p className="gcfm-subtitle">
            Are you sure you want to <strong>cancel</strong> <em>{talentName}</em> from your shortlist?
          </p>
        </div>

        <div className="gcfm-actions">
          <button className="gcfm-btn gcfm-btn-ghost" onClick={onClose}>
            Keep Shortlisted
          </button>
          <button
            className="gcfm-btn gcfm-btn-danger"
            onClick={() => {
              onConfirm?.();
              onClose?.();
            }}
          >
            Yes, Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
